import {
	getValueToPositionMapper,
	useDrawingArea,
	useXScale,
} from "@mui/x-charts/hooks";
import type { FC } from "react";
import type { InterpolatedPeriod } from "web_myplann/Portfolio/Helpers/interpolatedPeriods";

const FILL = "rgba(148, 163, 184, 0.18)";

type Props = {
	periods: InterpolatedPeriod[];
};

export const InterpolatedPeriodsOverlay: FC<Props> = ({ periods }) => {
	const { left, top, width, height } = useDrawingArea();
	const xScale = useXScale();

	if (periods.length === 0) {
		return null;
	}

	const toPosition = getValueToPositionMapper(xScale);
	const right = left + width;

	return (
		<g pointerEvents="none">
			{periods.map((period) => {
				const start = Math.max(left, toPosition(period.from));
				const end = Math.min(right, toPosition(period.to));

				if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
					return null;
				}

				return (
					<rect
						key={`${period.fromLabel}-${period.toLabel}`}
						x={start}
						y={top}
						width={end - start}
						height={height}
						fill={FILL}
					/>
				);
			})}
		</g>
	);
};
